<template>
    <div>

        <!-- forgot pass form -->
        <div v-if="state == 'forgot'">
            <div class="top">
                <h2>Forgot Password</h2>
                <p>Enter your email address below to receive a reset password link via email.</p>
            </div>
            <form action="#" @submit.prevent="forgotPassword">
                <div class="inprow">
                    <label>Email Address</label>
                    <input type="email" name="email" value="" v-model="email">
                </div>
                <div class="inprow">
                    <b-btn type="submit" variant="secondary" @click.prevent="forgotPassword">
                        <LoadingWheel v-if="isSubmitting" />
                        <span v-else>Send Reset Email</span>
                    </b-btn>
                    &nbsp;&nbsp;&nbsp;
                    <a href="#" @click.prevent="$emit('change-state', 'login')">login</a>
                </div>
                <div class="inprow err" v-if="forgotErr" v-html="forgotErr"></div>
            </form>
        </div>

        <!-- forgot success state -->
        <div v-if="state == 'forgot_sent'">
            <div class="top">
                <h2>Check your email</h2>
                <p>An email has been sent to with instructions on resetting your password.</p>
            </div>
            <hr />
            <div class="inprow">
                <a href="#" @click.prevent="$emit('change-state', 'login')">login</a>
            </div>
        </div>

    </div>
</template>

<script>
import isEmail from 'validator/lib/isEmail';
import $ from "jquery";
import LoadingWheel from './LoadingWheel.vue';

//
export default {
    name: 'AgentLogin',
    components: {
        LoadingWheel
    },
    data() {
        return {
            state: 'forgot',
            email: "",
            pass: "",

            isSubmitting: false,
            forgotErr: false

        };
    },
    computed: {},
    methods: {

        //
        forgotPassword() {
            var _this = this;

            //validate email
            if( ! isEmail(this.email) )
                return this.forgotErr = "Invalid email address supplied";

            //
            if( this.isSubmitting ) return;
            this.isSubmitting = true;
            this.forgotErr = false;
            
            
            //
            $.ajax({
                url: window.CoachingPanel.ajaxurl,
                type: 'post',
                data: {
                    email: this.email,
                    action: 'cpagentforgotpass'
                },
                success: function() {

                    //update the state
                    _this.state = 'forgot_sent';
                    
                },
                error: function( data ) {

                    _this.forgotErr = data.responseJSON.message;
                    _this.isSubmitting = false;

                }
            });

        }

    }
};
</script>
